import { fadeChangeMotion } from '@shared/motions/animations.ts';
import classnames from 'classnames';
import { AnimatePresence, motion, type Variants } from 'framer-motion';
import { type FC, memo, type ReactNode } from 'react';

interface LoadingScreenProps {
  loadingText?: string;
  visible?: boolean;
  fullScreen?: boolean;
  spinner?: ReactNode;
}

const LoadingScreen: FC<LoadingScreenProps> = ({
  visible = false,
  loadingText,
  fullScreen = false,
  spinner,
}) => {
  const variants: Variants = {
    inactive: {
      height: 'auto',
      width: 'auto',
    },
    active: {
      color: ['#60F', '#09F', '#F672AF', '#09F', '#60F'],
      transition: {
        type: 'tween',
        ease: 'easeIn',
        delay: 0,
        duration: 2,
        repeat: Number.POSITIVE_INFINITY,
        repeatType: 'reverse',
        repeatDelay: 1,
      },
    },
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          {...{
            ...fadeChangeMotion,
            transition: {
              ...fadeChangeMotion.transition,
              ease: 'easeInOut', // Use a valid easing string
            },
          }}
          className={classnames('flex gap-3 justify-center items-center bg-base-300 text-2xl', {
            'h-screen w-screen fixed top-0 left-0': fullScreen,
            'h-full w-full absolute top-0 left-0': !fullScreen,
            'z-9999': visible,
          })}
        >
          <motion.div
            className="flex gap-2"
            variants={variants}
            initial="inactive"
            animate="active"
          >
            {spinner ? spinner : <span className="loading loading-spinner loading-lg" />}
          </motion.div>
          {loadingText && <span>{loadingText}</span>}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default memo(LoadingScreen);
